import { useSuspenseQuery } from '@tanstack/react-query';
import { eventsUpcomingShortGet } from '@/api/plan/events/eventsUpcomingShortGet';

export const useUpcomingEvents = () => useSuspenseQuery({
    queryKey: ['upcomingEvents'],
    queryFn: () => eventsUpcomingShortGet().then(r => r.payload)
});
